/* Дисконт Винотека — Modern Motion (vanilla JS, без зависности) */
(function () {
  'use strict';
  window.__msMotion = true;
  var html = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Појавување при скрол */
  function setupReveal() {
    var targets = document.querySelectorAll([
      '.cdz-homepage .cdz-block-title',
      '.cdz-homepage .block-products .products',
      '.cdz-homepage .home-product-style22 .products-list-wrapper',
      '.cdz-homepage .wrapper-adv-style-09 .block-wrapper',
      '.cdz-homepage .cdz-banner',
      '.cdz-homepage .about-us-03-content-wrapper',
      '.cdz-categorypage .product-items',
      '.footer-style-07 .footer-col'
    ].join(','));
    if (!targets.length) return;

    targets.forEach(function (el) { el.classList.add('ms-reveal'); });

    /* каскада за решетки што НЕ се слајдери (слајдерите имаат свој transform) */
    document.querySelectorAll('.product-items.no_slider, .product-items.flex-grid:not(.owl-carousel), .footer-style-07 .footer-content-middle .row').forEach(function (grid) {
      Array.prototype.slice.call(grid.children).slice(0, 12).forEach(function (child, i) {
        child.classList.add('ms-reveal');
        child.style.setProperty('--ms-i', i);
      });
      grid.classList.remove('ms-reveal'); /* родителот не треба двојно */
    });

    if (reduce || !('IntersectionObserver' in window)) {
      document.querySelectorAll('.ms-reveal').forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    document.querySelectorAll('.ms-reveal').forEach(function (el) { io.observe(el); });
  }

  /* 2. Скрол: сенка на header + копче „горе" со прстен */
  function setupScroll() {
    var btn = document.createElement('button');
    btn.id = 'ms-top'; btn.type = 'button'; btn.setAttribute('aria-label', 'Врати се горе');
    var C = 2 * Math.PI * 22;
    btn.innerHTML = '<svg viewBox="0 0 48 48" aria-hidden="true"><circle class="ms-ring-bg" cx="24" cy="24" r="22"/>' +
      '<circle class="ms-ring" cx="24" cy="24" r="22" stroke-dasharray="' + C + '" stroke-dashoffset="' + C + '"/></svg><span class="ms-arrow" aria-hidden="true">↑</span>';
    document.body.appendChild(btn);
    var ring = btn.querySelector('.ms-ring');
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });

    var ticking = false;
    function update() {
      var y = window.pageYOffset || html.scrollTop;
      var max = Math.max(1, html.scrollHeight - window.innerHeight);
      html.classList.toggle('ms-scrolled', y > 8);
      btn.classList.toggle('is-visible', y > 600);
      ring.style.strokeDashoffset = C * (1 - Math.min(1, y / max));
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* 3. „Поп" на бројачот на кошничката кога се менува */
  function setupCartPop() {
    if (reduce || !('MutationObserver' in window)) return;
    function watch(el) {
      var last = el.textContent;
      new MutationObserver(function () {
        if (el.textContent !== last) {
          last = el.textContent;
          el.classList.remove('ms-pop'); void el.offsetWidth; el.classList.add('ms-pop');
        }
      }).observe(el, { childList: true, characterData: true, subtree: true });
    }
    document.querySelectorAll('.counter.qty').forEach(watch);
  }

  /* 4. Промоција: 3D навалување на производот кон глувчето (само десктоп со глувче) */
  function setupTilt() {
    if (reduce || !window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    document.querySelectorAll('.product-list-style-05 .product-item-top').forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        el.style.setProperty('--ms-ry', (x * 12).toFixed(2) + 'deg');
        el.style.setProperty('--ms-rx', (-y * 10).toFixed(2) + 'deg');
      });
      el.addEventListener('pointerleave', function () {
        el.style.setProperty('--ms-rx', '0deg');
        el.style.setProperty('--ms-ry', '0deg');
      });
    });
  }

  function init() { setupReveal(); setupScroll(); setupCartPop(); setupTilt(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
